import mdBanner from './../../assets/images/contact-us-page-banner.jpg'; // Adjust the path as necessary
import smBanner from './../../assets/images/home-page-banner-tab.jpg'; // Adjust the path as necessary
import mbBanner from './../../assets/images/home-page-banner-mobile.jpg'; // Adjust the path as necessary

function ContactUsBanner() {
  return (
    <>
        <section className='banner position-relative pt-0 pb-4 pb-mb-5'>
              <picture className='d-block pb-0 pb-md-0'>
                <source media="(max-width:575px)" srcSet={mbBanner}/>
                  <source media="(max-width:757px)" srcSet={smBanner}/>
                  
                  <img src={mdBanner} alt="" className='img-fluid w-100' />
              </picture>
              <div className='container max-1330 position-absolute top-0 left-0 right-0 bottom-0 mx-auto'>
                <div className="row align-items-center h-100">
                  <div className='col-md-7'>     
                    {/* <span className='breadcrum'>SAFE SHIPS <i className='dot'></i> CLEAN SEAS</span>           */}          
                    <h1 className="">Contact Us</h1>
                  </div>
                </div>
              </div>
        </section>
    </>
  )
}

export default ContactUsBanner;